/* eslint-disable camelcase */
import React from 'react';

import placeholder from './blog-placeholder.png';

import { styledHeaderImage } from './HeaderImageStyles';
import { LazyImage } from '../../../../slices/atoms';

const HeaderImage = (blog_header_image, list, extraClass) => {
  let renderHeaderImage;

  if (blog_header_image && blog_header_image.url) {
    renderHeaderImage = (
      <div className={extraClass} css={styledHeaderImage}>
        <LazyImage
          className={list}
          src={blog_header_image.url}
          alt={blog_header_image.alt || 'blog header'}
          maxwidth="790"
        />
      </div>
    );
  } else if (list === 'list') {
    renderHeaderImage = (
      <div css={styledHeaderImage}>
        <LazyImage className={list} src={placeholder} alt="blog header" size="3by2" />
      </div>
    );
  }

  return renderHeaderImage;
};

export default HeaderImage;
